import React, { useEffect, useState } from "react";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import { SlDrawer, SlButton } from "@shoelace-style/shoelace/dist/react";
import Select from "react-select";

function AssignOrder(props) {
  const [advetisers, setAdvertisers] = useState([]);
  const [advId, setAdvId] = useState();
  const [error, setError] = useState(false);
  const [advertiserObject, setAdvertiserObject] = useState({});
  const fetchAdvertisers = async () => {
    try {
      let res = await API({
        url: "/order/advertiser-details",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
        },
      });
      if (res.code === 200) {
        setAdvertisers(res.data);
        let obj = {};
        res.data?.map((item) => {
          obj[item.value] = item.label;
        });
        setAdvertiserObject(obj);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRequestClose = (event) => {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  };

  const handleClose = () => {
    props.setShow(false);
  };

  const handleAdvertiser = (e) => {
    setError(false);
    setAdvId(e.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!advId) {
      setError(true);
    } else {
      assignAdvertiser();
    }
  };

  const assignAdvertiser = async () => {
    try {
      let res = await API({
        url: "/order/assign-advertiser",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
          adv_id: advId,
        },
      });
      if (res.code === 200) {
        Toast("success", "Advertiser assigned Successfully");
        handleClose();
        props.loadData(props.search, props.currentPage);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleUnassign = async(id) => {
    try {
      let res = await API({
        url: "/order/unassign-advertiser",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
          adv_id: id,
        },
      });
      if (res.code === 200) {
        Toast("success", "Advertiser unassigned Successfully");
        props.setAssignedAdvertisers(prev => prev.filter(item => item!== id))
        props.loadData(props.search, props.currentPage);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (props.order_id) fetchAdvertisers();
  }, [props.order_id]);
  return (
    <>
      <SlDrawer
        label="Assign Advertiser"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": `${window.innerWidth <= 767 ? "100%" : '300px'}` }}
      >
        <div>
          <form onSubmit={handleSubmit}>
            <label className="form-label mb-1">Select Advertiser</label>
            <div className="mb-3">
              <Select
                label="Select Advertiser"
                defaultValue={advId}
                onChange={handleAdvertiser}
                options={advetisers}
              ></Select>
              {error && (
                <p className="text-red-600 mt-1">Advertiser is required</p>
              )}
            </div>
            <div className="d-flex flex-grow-1">
              <SlButton type="submit" variant="primary" size="small">
                Assign
              </SlButton>
            </div>
          </form>
          <h3 className="my-2">Assigned Advertisers</h3>
          {Object.keys(advertiserObject).length > 0 &&
          props.assignedAdvertisers?.length > 0 ? (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Advertiser Name</th>
                  <th>Unassign</th>
                </tr>
              </thead>
              <tbody>
                {props.assignedAdvertisers?.map((item, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{advertiserObject[item]}</td>
                      <td><div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked onChange={() => handleUnassign(item)}/>
  <label class="form-check-label" for="flexSwitchCheckChecked"></label>
</div></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <h3 className="text-center text-gray-600">None</h3>
          )}
        </div>
      </SlDrawer>
    </>
  );
}

export default AssignOrder;
